/*
|--------------------------------------------------------------------------
| Views: Article
|--------------------------------------------------------------------------
*/

/**
 * Featured Single
 * @namespace
 */
__gh__webApp.views.article = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){

		var utilities		= __gh__webApp.utilities,
			articleJSON		= bucket.items.main[0],
			articlePage		= __gh__webApp.articlePage,
			trackArticle	= __gh__webApp.utilities.tracker.trackArticle;

		articlePage.loadArticle.callbacks({"articleObject":articleJSON,"articleDOM":"#article"});
		articlePage.consumerSurvey.showSurvey(articleJSON);
		trackArticle.mainArticle({"articleObject":articleJSON});
	},

	"prepItemData": function(items){
		var item 			= items[0],
			relatedTypes	= [],
			relatedItems 	= item.relatedContent.items;

		//Related types array to check for related icons in view
		for(var i=0; i<relatedItems.length; i++){
			var relatedItem = relatedItems[i],
				type 		= relatedItem.type;
				type 		= (type == "images") ? "gallery" : type;
				if(relatedItem.items.length){
					relatedTypes.push(type);
				}
		}
		items[0].relatedContent.types = relatedTypes;

		return items;
	},
	
	/**
	 * Get a subview for the article..ie.Imagelist
	 */
	"getArticleSubView": function(bucket){
		var commonJS 		= __gh__webApp.common,
			views			= __gh__webApp.views,
			articleObject	= bucket.items.main[0];
			
		if (commonJS.isObjectPropertySet(articleObject,"subView") && commonJS.isObjectPropertySet(views, "article"+articleObject.subView + ".getSubView")){
			return views["article"+articleObject.subView].getSubView(bucket)
		}
		
		return false;
	},


	"getSubView": function(bucket){
		var items				= bucket.items.main;
		
		// Prep Article
		bucket.items.main		= this.prepItemData(items);
		
		var articleSubView 		= this.getArticleSubView(bucket)
		if (articleSubView){
			return articleSubView;
		}
		
		bucket.view.name = "buckets/article/default";
		return bucket;

	}
};